import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.map";

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React, { useContext } from 'react';
import Block from 'wfui-digital-core/es/Block';
import Tile from '../tile/Tile';
import TileLink from '../tile-link/TileLink';
import icons from '../icons/icons';
import StickyFooterContext from '../context/StickyFooterContext';
import MenuButton from '../menu-button/MenuButton';
import logger from '../../../lib/logger/logger';
import styles from './Tiles.less';

var getIcon = function getIcon(iconName) {
  var icon;

  if (icons[iconName]) {
    icon = icons[iconName];
  } else {
    logger.error("StickyFooter Icon ".concat(iconName, " not found"));

    icon = function icon() {
      return null;
    };
  }

  return icon;
};

var Tiles = function Tiles() {
  var _useContext = useContext(StickyFooterContext),
      menuConfig = _useContext.menuConfig,
      getString = _useContext.getString,
      windowWidth = _useContext.windowWidth;

  var links = menuConfig.sections[0].links;
  var menu = menuConfig.sections[1];
  var tileCount = links.length + 1;
  var navMaxWidth = 112 * tileCount;
  var tileMinWidth = windowWidth / tileCount - 4 > 112 ? 112 : windowWidth / tileCount - 4; // 4px gets added as padding

  var tileMaxWidth = 112;
  return /*#__PURE__*/React.createElement(Block, {
    el: "nav",
    "aria-label": getString('stickyfooter.nav.label'),
    className: styles.tiles,
    style: {
      navMaxWidth: navMaxWidth
    }
  }, /*#__PURE__*/React.createElement(Block, {
    el: "ul",
    layout: true,
    horizontal: true
  }, links.map(function (link, index) {
    return /*#__PURE__*/React.createElement(Tile, {
      key: "".concat(link.label, "-").concat(index)
    }, /*#__PURE__*/React.createElement(TileLink, {
      index: index,
      link: link,
      icon: getIcon(link.icon),
      tileCount: tileCount,
      minWidth: tileMinWidth,
      maxWidth: tileMaxWidth,
      id: index === 0 ? 'bnb-first-link' : null
    }));
  }), /*#__PURE__*/React.createElement(Tile, null, /*#__PURE__*/React.createElement(MenuButton, {
    menu: menu,
    icon: icons['menu'],
    tileCount: tileCount,
    minWidth: tileMinWidth,
    maxWidth: tileMaxWidth
  }))));
};

export default Tiles;